// src/pages/TermsOfService.tsx  (/terms-of-service)
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link } from "@mui/material";
import LegalPageLayout, { LegalSection, LegalText, LegalList } from "../components/LegalPageLayout";
import { LEGAL } from "../legal/legalConfig";

const TermsOfService: React.FC = () => (
    <LegalPageLayout title="Általános Szerződési Feltételek" updated={LEGAL.effectiveDate}>
        <LegalSection title="1. A szolgáltató adatai">
            <LegalList
                items={[
                    <>Név: {LEGAL.companyName}</>,
                    <>Székhely: {LEGAL.address}</>,
                    <>Adószám: {LEGAL.taxNumber}</>,
                    <>Nyilvántartási szám: {LEGAL.registrationNumber}</>,
                    <>E-mail: {LEGAL.email}</>,
                    <>Telefon: {LEGAL.phone}</>,
                    ...(LEGAL.hostingProvider ? [<>Tárhelyszolgáltató: {LEGAL.hostingProvider}</>] : []),
                ]}
            />
        </LegalSection>

        <LegalSection title="2. A feltételek hatálya">
            <LegalText>
                Jelen Általános Szerződési Feltételek (ÁSZF) a {LEGAL.website} weboldal használatára és az azon keresztül elérhető
                szolgáltatások igénybevételére vonatkoznak. A weboldal használatával, illetve a regisztrációval a felhasználó
                elfogadja a jelen ÁSZF-et.
            </LegalText>
        </LegalSection>

        <LegalSection title="3. A szolgáltatások">
            <LegalText>
                A {LEGAL.brandName} többek között az alábbi szolgáltatásokat kínálja: magánóra, gyermekagykontroll, tanulási
                tréning, Chillag. A szolgáltatások tartalma, ára és elérhetősége a weboldalon, illetve az egyedi megállapodásban
                szerepel.
            </LegalText>
            <LegalText>
                A Chillag egy később megjelenő mobilalkalmazás, amelyre ugyanezen ÁSZF és ugyanezek az adatvédelmi szabályok
                (Adatvédelmi nyilatkozat) vonatkoznak. Az alkalmazásban a szolgáltatások közül kizárólag a gyermekagykontroll
                kerül meghirdetésre. A regisztrációval a felhasználó elfogadja, hogy a Csillagtanodához kötődő hírleveleket
                e-mailben megkapja; erről bármikor leiratkozhat.
            </LegalText>
        </LegalSection>

        <LegalSection title="4. Regisztráció és felhasználói fiók">
            <LegalList
                items={[
                    "A regisztráció a weboldalon e-mail címmel vagy más, a bejelentkezési oldalon elérhető módon történik.",
                    "A regisztrációt és a bejelentkezést a Clerk hitelesítési szolgáltatás kezeli. A weboldal saját adatbázisa kizárólag arra szolgál, hogy a Clerk, a GHL és az oldal szerepkör (jogosultság) funkciói szinkronban legyenek.",
                    "A felhasználó köteles valós adatokat megadni, és a belépési adatait titokban tartani.",
                    "A fiókkal kapcsolatos tevékenységekért a felhasználó felel.",
                    "Gyermek (18 év alatti) részére a regisztrációt és a szolgáltatások igénybevételét a szülő vagy törvényes képviselő végezheti, illetve engedélyezheti.",
                    "A felhasználó a fiókját bármikor törölheti. A szolgáltató jogosult a fiókot felfüggeszteni vagy törölni, ha a felhasználó megsérti az ÁSZF-et.",
                ]}
            />
        </LegalSection>

        <LegalSection title="5. Árak, megrendelés és fizetés">
            <LegalText>
                A weboldalon jelenleg nincs fizetős szolgáltatás, ezért online megrendelés és fizetés sem történik.
            </LegalText>
        </LegalSection>

        <LegalSection title="6. Elállási jog">
            <LegalText>
                A fogyasztónak minősülő felhasználó a távollévők között kötött szerződéstől a 45/2014. (II. 26.) Korm. rendelet
                szerint indokolás nélkül elállhat a szerződéskötéstől számított 14 napon belül. Szolgáltatás esetén az elállási
                határidő a szerződés megkötésétől számít. Ha a fogyasztó kifejezett kérésére a szolgáltatás teljesítése az elállási
                határidő lejárta előtt megkezdődött, az elállás esetén a fogyasztó a teljesítés addigi arányos részét köteles
                megtéríteni. Az elállási szándékot a {LEGAL.email} címen lehet jelezni.
            </LegalText>
        </LegalSection>

        <LegalSection title="7. Felelősség">
            <LegalList
                items={[
                    "A szolgáltató törekszik a weboldal folyamatos és hibamentes elérhetőségére, de ezt nem garantálja; karbantartás vagy rajta kívül álló ok miatt a szolgáltatás szünetelhet.",
                    "A weboldalon közölt tartalmak tájékoztató jellegűek, nem minősülnek orvosi, pszichológiai vagy más szakmai tanácsadásnak.",
                    "A felhasználó által megadott adatok valódiságáért a felhasználó felel.",
                    "A fenti korlátozások nem érintik a jogszabályból eredő, kizárhatatlan felelősséget.",
                ]}
            />
        </LegalSection>

        <LegalSection title="8. Szellemi tulajdon">
            <LegalText>
                A weboldal és a szolgáltatások tartalma (szövegek, képek, logó, oktatási anyagok, letölthető tartalmak) a szolgáltató
                vagy a jogosultak szerzői jogi védelme alatt áll. Az anyagok a szolgáltató előzetes írásbeli engedélye nélkül nem
                másolhatók, nem terjeszthetők és nem hasznosíthatók üzleti célra; személyes használatra a felhasználó igénybe veheti őket.
            </LegalText>
        </LegalSection>

        <LegalSection title="9. Adatkezelés">
            <LegalText>
                A személyes adatok kezeléséről az{" "}
                <Link component={RouterLink} to="/privacy-policy">Adatvédelmi nyilatkozat</Link> tájékoztat.
            </LegalText>
        </LegalSection>

        <LegalSection title="10. Panaszkezelés és jogérvényesítés">
            <LegalText>
                Panaszával forduljon a szolgáltatóhoz a {LEGAL.email} címen. A szolgáltató a panaszt a beérkezésétől számított
                30 napon belül érdemben megválaszolja. Ha a panasz nem vezet eredményre, a fogyasztó az alábbi testülethez
                fordulhat: {LEGAL.conciliationBody}. Az online vitarendezési platform: {" "}
                <Link href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                    ec.europa.eu/consumers/odr
                </Link>
                . A fogyasztó a bírósághoz is fordulhat.
            </LegalText>
        </LegalSection>

        <LegalSection title="11. Záró rendelkezések">
            <LegalText>
                A szolgáltató az ÁSZF-et egyoldalúan módosíthatja; a módosítás a weboldalon való közzétételkor lép hatályba, és a
                már megkötött szerződésekre nem hat vissza. A jelen ÁSZF-re a magyar jog az irányadó.
            </LegalText>
        </LegalSection>
    </LegalPageLayout>
);

export default TermsOfService;